export default __webpack_public_path__ + "static/media/MallEvent_07.86861199.png";